export interface ValidationResult {
  isValid: boolean;
  error?: string;
}

export const validateEmail = (email: string): ValidationResult => {
  if (!email.trim()) {
    return { isValid: false, error: 'Email is required' };
  }
  
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  if (!emailRegex.test(email)) {
    return { isValid: false, error: 'Please enter a valid email address' };
  }
  
  return { isValid: true };
};

export const validateName = (name: string): ValidationResult => {
  if (!name.trim()) {
    return { isValid: false, error: 'Name is required' };
  }
  
  if (name.trim().length > 100) {
    return { isValid: false, error: 'Name must be 100 characters or less' };
  }
  
  return { isValid: true };
};

export const validateMessage = (message: string): ValidationResult => {
  if (!message.trim()) {
    return { isValid: false, error: 'Message is required' };
  }
  
  if (message.trim().length > 2000) {
    return { isValid: false, error: 'Message must be 2000 characters or less' };
  }
  
  return { isValid: true };
};

export const validateSubject = (subject: string): ValidationResult => {
  if (subject.trim().length > 200) {
    return { isValid: false, error: 'Subject must be 200 characters or less' };
  }
  
  return { isValid: true };
};

export const isSpamSubmission = (honeypot: string, submittedMs: number): boolean => {
  // Check honeypot field
  if (honeypot.trim() !== '') {
    return true;
  }
  
  // Check minimum time (3 seconds)
  if (submittedMs < 3000) {
    return true;
  }
  
  return false;
};